import { constants } from '../config';

/* **** showProductDetail *** */
export const showProductDetail = (show, value, selected) => ({
  type: constants.SHOW_PRODUCT_DETAIL,
  show,
  value,
  selected,
});
